import { render, staticRenderFns } from "./MarketingMerchantsInsert.vue?vue&type=template&id=3b1ed6d3&scoped=true&"
import script from "./MarketingMerchantsInsert.vue?vue&type=script&lang=js&"
export * from "./MarketingMerchantsInsert.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMerchantsInsert.vue?vue&type=style&index=0&id=3b1ed6d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ed6d3",
  null
  
)

export default component.exports